import BookLibraryComponent from '../components/books/BookLibrary';

const BookLibrary = () => {
    return <BookLibraryComponent />;
};

export default BookLibrary;
